import { createSlice } from "@reduxjs/toolkit";

// Initial state
const initialState = {
  from: null,
  to: null,
  label: null,
};

// Slice
const destinationSlice = createSlice({
  name: "destination",
  initialState,
  reducers: {
    initDestination(state) {
      return {
        ...state,
        from: null,
        to: null,
        label: null,
      };
    },
    setDestination(state, action) {
      const { from, to, label = null } = action.payload;
      return {
        ...state,
        from,
        to,
        label,
      };
    },
  },
});

export const { initDestination, setDestination } = destinationSlice.actions;

export default destinationSlice.reducer;
